import React, { useState, useEffect } from "react";
import { Tabs, Tab } from "@appkit4/react-components/tabs";
import CreateUser from "./createUser";
import ManageUsers from "./users";
import Organization from "./organizations";
import Role from "./role";
import displayToastMessage from "../../../components/Common/Alert/displayToastMessage";
import APIService from "../../../services/apiAxiosService.js";
import useHttp from "../../../hooks/useHttp.js";
import UsersUnlock from "./usersUnlock.js";
import EditUsers from "./editUsers.js";
import Notification from "./notification.js";
import EditAssessor from "./editAssessor.js";
function ManagementUser() {
  const [currentTab, setCurrentTab] = useState(0);
  const [modalVisible, setModalVisible] = useState(false);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userRole, setUserRole] = useState([]);
  const [userList, setUserList] = useState([]);
  const [allOrganizations, setAllOrganizations] = useState([]);
  const [rolesLoader, setRolesLoader] = useState(false);
  const { sendRequest: getAllUserList } = useHttp();
  const { sendRequest: deleteUserRecord} = useHttp();
  const { sendRequest: getRoles } = useHttp();
  const { sendRequest: getUserList } = useHttp();
  const { sendRequest: fetchAllOrganizations } = useHttp();

  const { sendRequest: DeleteRoles } = useHttp();
  const [deletemodalVisible, setDeletemodalVisible] = useState(false);

  useEffect(() => {
    getUserListData();
    getRolesData();
    getAllOrganizations();
    getCreatedUserList();
  }, []);

  const getAllOrganizations = async () => {
    fetchAllOrganizations(APIService.fetchAllOrganizations(), (data) => {
      setAllOrganizations(data.MSG)
    })
  };


  const getUserListData = async (users) => {
    getAllUserList(APIService.getAllUserList(), (data) => {
      setUsers(data.MSG)
    })
  };

  const getRolesData = async (users) => {
    getRoles(APIService.getRoles(), (data) => {
      setUserRole(data.MSG)
    })
  };
  const getCreatedUserList = async () => {
    getUserList(APIService.getUserList(), (data) => {
      setUserList(data.MSG)
    })
  };

  const handleTabs = (v) => {
    setCurrentTab(v);
  };

  const handleDelete = async (data, setSearch) => {
    setLoading(true);
    try {
      deleteUserRecord(APIService.deleteUserRecord(data), (result) => {
        if (result.CODE) {
          setLoading(false);
          displayToastMessage(result.MSG, "success");
          getUserListData();
          setModalVisible(false);
          setSearch("");
        } else {
          setLoading(false);
          getUserListData();
          displayToastMessage("Something went wrong!", "error");
          setModalVisible(false);
          setSearch("");
        }
      })
    } catch (error) {
      setLoading(false);
      getUserListData();
      displayToastMessage("Something went wrong!", "error");
      setModalVisible(false);
      setSearch("");
    }
  };

  const handleCancel = () => {
    setModalVisible(false);
  };

  const handelDeleteRole = async (data, setSearch, getOrgRoles) => {
    let email={email:sessionStorage.getItem("email")};
    Object.assign(data,email);
    setRolesLoader(true)
    DeleteRoles(APIService.DeleteRoles(data), () => {
    displayToastMessage("Roles deleted successfully", "success");
    getUserListData();
    setDeletemodalVisible(false);
    setSearch("");
    getOrgRoles();
    }, 
    () => {
      displayToastMessage("Something went wrong, Please try again!", "error");
      setDeletemodalVisible(false);
      setSearch("");
    })
    setRolesLoader(false)
  }
  return (
    <div className="user-management-container">
      <Tabs
        activeIndex={currentTab}
        onTabChange={handleTabs}
        className="a-tab-item-padding-10"
      >
        <Tab value="organization-role" label="Organization - Role Pair">
          <ManageUsers
            user={users}
            reloadData={getUserListData}
            handleDelete={handleDelete}
            loading={loading}
            userRole={userRole}
            userList={userList}
            modalVisible={modalVisible}
            setmodalVisible={setModalVisible}
            handleCancel={handleCancel}
          />
        </Tab>
        <Tab value="organization" label="Organization">
          <Organization allOrganizations={allOrganizations} reloadData={getAllOrganizations} reloadUserData={getUserListData} />
        </Tab>
        <Tab value="role" label="Role">
          <Role
            allOrganizations={allOrganizations}
            Roles={userRole}
            handleDelete={handelDeleteRole}
            loader={rolesLoader}
            reloadData={getUserListData}
            deletemodalVisible={deletemodalVisible}
            setDeletemodalVisible={setDeletemodalVisible}
          />
        </Tab>
        <Tab value="create" label="Create User">
          <CreateUser
            SetTab={setCurrentTab}
            reloadData={getUserListData}
            createdUserList={getCreatedUserList}
            userRole={userRole}
          />
        </Tab>
        <Tab value="unlock" label="Unlock User Accounts">
          <UsersUnlock></UsersUnlock>
        </Tab>
        <Tab value="edit_user" label="Edit User Accounts">
          <EditUsers />
        </Tab>
        <Tab value="edit_user" label="Reminder Notification Configuration">
          <Notification allOrganizations={allOrganizations}/>
        </Tab>
        <Tab value="edit_assessor" label="Edit Assessor for Assessments">
          <EditAssessor />
        </Tab>
      </Tabs>
    </div>
  );
}
export default ManagementUser;
